<template>
  <div class='press-result'>
    <h2>出版社数据</h2>
    
    <div class='content'>
      <div v-loading='loading' class='table-wrapper'>
        <!-- 列表 -->

        <table class='table'>
          <thead>
            <tr>
              <td v-for='item in tableItems' :key='item.idx' :style='{width:item.width}'>{{ item.label }}</td>
            </tr>
          </thead>
                
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              
              <td v-for='t in tableItems' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "isSelected"' class='cell'>
                <input type="checkbox" name="checkbox1" value="1" class="box" >
                </div>
                <div class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <page :total='total' @change='changePage'/>
      <a href='javascript:;' class='btn-back' @click='clickSubmit'>提交订单</a>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page'

import { PRESS_INFO, PRESS_INFO_BLUR } from '@/api'

export default {
  components: {
    Page,
    Type:1
  },

  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'price':
          result = '￥' + val
          break
                
        default:
          result = val
          break    
      }
      return result
    }
  },
  data() {
    return {
      loading: false,
      page: 1,
      total: 0,
      tableItems: [
        { idx: 1, label: '序号', props: 'idx', width: '50px' },
       { idx: 2, label: '选择', props: 'isSelected', width: '50px'},
        { idx: 3, label: '书名', props: 'book_name', width: '220px' },
        { idx: 4, label: '丛书名', props: 'series_name', width: '180px' },
        { idx: 5, label: '出版机构', props: 'press', width: '120px' },
        { idx: 6, label: '作者', props: 'author', width: '100px' },
        { idx: 7, label: '价格', props: 'price', width: '80px' },
        { idx: 8, label: '适用分类', props: 'apply_classification', width: '80px' },
        { idx: 9, label: '适用专业', props: 'apply_profession', width: '80px' },
        { idx: 10, label: '社内分类', props: 'clubs_classify', width: '120px' },
        { idx: 11, label: '学科分类编号', props: 'discipline_class_no', width: '80px' },
        { idx: 12, label: '社内学科分类1',props: 'discipline_class1', width: '120px' },
        { idx: 13, label: '社内学科分类2',props: 'discipline_class2', width: '120px' },
        { idx: 14, label: '本季征订号', props: 'this_solicit_num', width: '90px' },
        { idx: 15, label: '上季征订号', props: 'last_solicit_num', width: '90px' },
        { idx: 16, label: '分册', props: 'fascicle', width: '80px' },
        { idx: 17, label: 'ISBN', props: 'isbn', width: '150px' },
      ],
      list: [],
    }
  },

  computed: {
    params() {
      return this.$store.state.pressParams
    }
  },

  created() {
    this.setActiveBar('PRESS')
    this.getPressInfo()
  },
  methods: {
    toggleSelectedStatus(i){
      console.log(this.list)
      this.list.forEach((val,index)=>{
        if(val.id==i.id){
          !this.list[index].isSelected
        }
      })
    },
    clickSubmit(){
      console.log(1212)
      this.$store.commit('setPressParams',this.form)
      this.goRouter('/presssubmit')
    },
    // 翻页
    changePage(val) {
      this.page = val
      this.getPressInfo()
    },

    // 获取出版社信息
    getPressInfo() {
      if (this.params.keyword) this.getPressBlur()
      else this.getPress()
    },

    // 分类搜索
    getPress() {
      let obj = {
        page: this.page
      }
      let para = Object.assign(obj,this.params)
      this.loading = true
      PRESS_INFO(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.total = res.data.total
          this._formatList(res.data.data)
        }
      })
    },

    // keyword模糊搜索
    getPressBlur() {
      let para = {
        page: this.page,
        keyword: this.params.keyword
      }
      this.loading = true
      PRESS_INFO_BLUR(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.total = res.data.total
          this._formatList(res.data.data)
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        this.list.push(e)
      })
    },
    //选中 项
    toggleType(){

    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.press-result {
  width: 1200px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    text-align: center;
  }

  .content {
    margin-top: 44px;
    width: 1200px;
    padding-bottom: 30px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      position: relative;

      // 列表
      .table {
        width: 1500px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }

    .btn-back {
      display: block;
      height: 40px;
      width: 250px;
      color: #ffffff;
      font-size: 20px;
      line-height: 40px;
      background: @blue-d;
      border-radius: 5px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
.content .box{

    outline: thick !important;
    -webkit-appearance: thick !important; 
    -moz-appearance: thick !important;
    appearance: thick !important;
}

</style>




// WEBPACK FOOTER //
// src/pages/PressResult.vue